module.exports = __webpack_public_path__ + "img/148.979d3b5f.jpg";